import { render, staticRenderFns } from "./PanelHeading.vue?vue&type=template&id=7a74f3d0&"
import script from "./PanelHeading.vue?vue&type=script&lang=js&"
export * from "./PanelHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports